<template>
    <div>
        <Box  @close="cerrar(false)" :width="'800px'">
            <template #top>Registrar Producto</template>
            <template #center>
                <div class="nj-card nj-cols">
                    <div class="nj-cols form c2">
                        <div>
                            <div class="nj-label">Tipo Producto (N1)</div>
                            <select class="nj-select" v-model="producto_venta.pti_id_parent" @change="seleccionarNivel2()">
                                <option></option>
                                <option v-for="item in producto_venta_tipos_n1" :key="item.pti_id" :value="item.pti_id">{{ item.pti_nombre }}</option>
                            </select>
                        </div>
                        <div>
                            <div class="nj-label">Tipo Producto (N2)</div>
                            <select class="nj-select" v-model="producto_venta.pti_id">
                                <option></option>
                                <option v-for="item in producto_venta_tipos_n2" :key="item.pti_id" :value="item.pti_id">{{ item.pti_nombre }}</option>
                            </select>
                        </div>
                        <div>
                            <div class="nj-label">Grupo</div>
                            <select class="nj-select" v-model="producto_venta.pvt_grupo">
                                <option></option>
                                <option v-for="item in producto_venta_grupos" :key="item.id" :value="item.id">{{ item.nombre }}</option>
                            </select>
                        </div>
                        <div>
                            <div class="nj-label">Marcas</div>
                            <select class="nj-select" v-model="producto_venta.mar_id">
                                <option></option>
                                <option v-for="item in marcas" :key="item.mar_id" :value="item.mar_id">{{ item.mar_nombre }}</option>
                            </select>
                        </div>
                        <div>
                            <div class="nj-label">Unidad medida</div>
                            <select class="nj-select" v-model="producto_venta.unm_id">
                                <option></option>
                                <option v-for="item in unidades_medida" :key="item.unm_id" :value="item.unm_id">{{ item.unm_simbolo }}</option>
                            </select>
                        </div>
                        <div>
                            <div class="nj-label">Nombre</div>
                            <input type="text" class="nj-text" v-model="producto_venta.pvt_nombre">
                        </div>
                    </div>
                    <div>
                        <div class="nj-label">Descripcion</div>
                        <textarea class="nj-text" rows="5" v-model="producto_venta.pvt_descripcion"></textarea>
                    </div>
                    <div class="nj-cols form c2 l-c4">
                        <div>
                            <div class="nj-label">Precio minimo</div>
                            <input type="text" class="nj-text" v-model="producto_venta.pvt_precio_minimo">
                        </div>
                        <div>
                            <div class="nj-label">Precio máximo</div>
                            <input type="text" class="nj-text" v-model="producto_venta.pvt_precio">
                        </div>
                        <div>
                            <div class="nj-label">Precio con IGV</div>
                            <input type="text" class="nj-text" v-model="pvt_precio_igv" disabled>
                        </div>
                        <div>
                            <div class="nj-label">Stock</div>
                            <input type="text" class="nj-text" v-model="producto_venta.pvt_stock">
                        </div>
                    </div>
                </div>
            </template>
            <template #bottom>
                <button class="nj-button c-green" @click="registrar()"><i class=" mdi-content-save"></i>Registrar</button>
            </template>
        </Box>
    </div>
</template>

<script>
import { AppService, ResponseStatus } from "../../services"
import ProductoVentaService from "../../services/ProductoVentaService"
import ProductoVentaTipoService from "../../services/ProductoVentaTipoService"
import Toast from "../../util/toast"
import { Box } from "../components"

export default {
    name: "RegistrarProductoVenta",
    components: {
        Box
    },
    data() {
        return {
            producto_venta: {
                pti_id: null
                , mar_id: null
                , unm_id: null
                , pvt_nombre: null
                , pvt_descripcion: null
                , pvt_precio: null
                , pvt_precio_minimo: null
                , pvt_stock: null
            },
            marcas: [],
            unidades_medida: [],
            producto_venta_grupos: [],
            producto_venta_tipos_n1: [],
            producto_venta_tipos_n2: [],
        }
    },
    props: {

    },
    computed: {
        pvt_precio_igv() {
            return Math.round(this.producto_venta.pvt_precio * 1.18 * 100) / 100
        }
    },
    methods: {
        registrar() {
            let errors = 0
            if (this.producto_venta.pti_id == null) errors++
            if (this.producto_venta.mar_id == null) errors++
            if (this.producto_venta.unm_id == null) errors++
            if (this.producto_venta.pvt_nombre == null) errors++
            if (this.producto_venta.pvt_descripcion == null) errors++
            if (this.producto_venta.pvt_precio == null) errors++
            if (this.producto_venta.pvt_precio_minimo == null) errors++
            if (this.producto_venta.pvt_stock == null) errors++
            if (errors == 0) {
                ProductoVentaService.registrar({
                    producto_venta: this.producto_venta
                }).then(
                    response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.cerrar(true)
                        }
                        else {
                            Toast.error(response.message)
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            }
            else {
                Toast.error("Falta ingresar datos para registrar el producto-venta")
            }
        },
        seleccionarNivel2() {
            this.producto_venta_tipos_n2 = []
            if (this.producto_venta.pti_id_parent) {
                ProductoVentaTipoService.buscar({
                    producto_venta_tipo: {
                        pti_parent: this.producto_venta.pti_id_parent
                    }
                }).then(
                    response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.producto_venta_tipos_n2 = response.data
                        }
                        else {
                            Toast.error(response.message)
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            }
        },
        cerrar(condition) {
            this.$emit("close", condition)
        },
    },
    mounted() {
        AppService.getData(["marcas", "unidades_medida", "producto_venta_tipos", "producto_venta_grupos"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.marcas = response.data.marcas
                    this.unidades_medida = response.data.unidades_medida
                    this.producto_venta_tipos_n1 = response.data.producto_venta_tipos
                    this.producto_venta_grupos = response.data.producto_venta_grupos
                }
                else {
                    Toast.error(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped></style>